import { render, staticRenderFns } from "./FormaOkvir.vue?vue&type=template&id=81724612"
import script from "./FormaOkvir.vue?vue&type=script&lang=js"
export * from "./FormaOkvir.vue?vue&type=script&lang=js"
import style0 from "./FormaOkvir.vue?vue&type=style&index=0&id=81724612&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports